import { createComponent, setValueById, addEventListenerById } from './ComponentHelpers'
import ConfirmDialog from '../components/shared/Dialog/ConfirmDialog'

export async function alertConfirm(title, body, confirmButtonText, closeButtonText) {
    createComponent(ConfirmDialog).$mount()

    setValueById('dialog-title', title)
    setValueById('dialog-body', body)
    
    if (confirmButtonText)
        setValueById('continue-btn', confirmButtonText);
    
    if (closeButtonText)
        setValueById('close-btn', closeButtonText)

    return new Promise((resolve) => {
        addEventListenerById('click', 'continue-btn', () => resolve({ isConfirmed: true }))
        addEventListenerById('click', 'close-btn', () => resolve({ isConfirmed: false }))
    })
}